<script lang="ts">
    import { cn } from "../cn";
    export let forId: string | undefined = undefined;
    let className = "";
    export { className as class };
</script>

<label
    for={forId}
    class={cn(
        "text-sm font-medium leading-none text-[var(--foreground)] select-none",
        className,
    )}
>
    <slot />
</label>
